<template>
  <div>
    <v-container class="ml-10">
      <p class="display-1 mt-7">쇼핑몰 정품 인증 설정</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        쇼핑몰에 정품 인증 페이지를 제공하여 고객이 인증 받을 수 있게 합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        PC와 모바일 화면을 만들어 사용하며, 해당 페이지에 안내 문구 설정이
        가능합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        쇼핑몰 구현에 따른 소스 삽입은 처리해드리오니 고객센터
        (0506-770-7770)으로 연락주세요.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        친절하게 처리해드리겠습니다.
      </p>

      <InfoTextSetting></InfoTextSetting>
    </v-container>
  </div>
</template>

<script>
import InfoTextSetting from "@/components/shoplus_authservice/setting/InfoTextSetting.vue";

export default {
  components: {
    InfoTextSetting,
  },
};
</script>
